import React from 'react';

import ProductDetailPanel from '../../ProductDetailPanel';
import BaseForm from '../../../../../components/form/BaseForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import InputForm from '../../../../../components/form/InputForm';
import CountOfTotal from '../../../../../components/CountOfTotal';
import {
  MAXIMUM_NUMBER_OF_PRODUCT_AS_INFORM_TEXT,
  MAXIMUM_NUMBER_OF_PRODUCT_CAUTIONS_TEXT,
  MAXIMUM_NUMBER_OF_PRODUCT_MANUFACTURER_TEXT,
  MAXIMUM_NUMBER_OF_PRODUCT_ORIGIN_TEXT,
  MAXIMUM_NUMBER_OF_PRODUCT_QUALITY_ASSURANCE_STANDARD_TEXT,
  PRODUCT_DETAIL_PAGE_PANEL_NAME,
} from '../../../../../constants/service/app/productConstants';
import { setDash, setPhoneFormat } from '../../../../../lib/common';
import { compareProductVersion } from '../../../../../lib/utils';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';

const ProductAfterService = (props) => {
  const { isEditable, form, initialValue, isCompare, comparisonData, ...res } = props;
  const { asPhone, kakaoAccount, origin, manufacturer } = initialValue;
  const { asInform, caution, qualityAssurance } = form.getFieldsValue();

  return (
    <ProductDetailPanel
      name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_AFTER_SERVICE}
      className="product-after-service"
      title="A/S 정보"
      isCompare={isCompare}
      {...res}
    >
      <div className="panel-body">
        <BaseForm label="A/S 전화번호" content={setDash(setPhoneFormat(asPhone))} />

        <BaseForm label="카카오톡 (플러스친구)" content={setDash(kakaoAccount)} />

        <TextAreaForm
          form={form}
          label={
            <span>
              A/S 안내
              <CountOfTotal content={asInform} maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_AS_INFORM_TEXT} />
            </span>
          }
          name="asInform"
          className={isCompare && compareProductVersion(asInform, comparisonData.asInform)}
          rules={[formRequiredRules(true, REQUIRED_MSG)]}
          isEditable={isEditable}
          initialValue={initialValue.asInform}
          maxLength={MAXIMUM_NUMBER_OF_PRODUCT_AS_INFORM_TEXT}
          rows={6}
        />

        <TextAreaForm
          form={form}
          label={
            <span>
              착용 시 주의 사항
              <CountOfTotal content={caution} maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_CAUTIONS_TEXT} />
            </span>
          }
          name="caution"
          className={isCompare && compareProductVersion(caution, comparisonData.caution)}
          isEditable={isEditable}
          initialValue={initialValue.caution}
          maxLength={MAXIMUM_NUMBER_OF_PRODUCT_CAUTIONS_TEXT}
          rows={6}
        />

        <TextAreaForm
          form={form}
          label={
            <span>
              품질보증 기준
              <CountOfTotal
                content={qualityAssurance}
                maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_QUALITY_ASSURANCE_STANDARD_TEXT}
              />
            </span>
          }
          name="qualityAssurance"
          className={isCompare && compareProductVersion(qualityAssurance, comparisonData.qualityAssurance)}
          isEditable={isEditable}
          initialValue={initialValue.qualityAssurance}
          maxLength={MAXIMUM_NUMBER_OF_PRODUCT_QUALITY_ASSURANCE_STANDARD_TEXT}
          rows={6}
        />

        <InputForm
          form={form}
          label="제조국"
          name="origin"
          className={isCompare && compareProductVersion(origin, comparisonData.origin)}
          rules={[formRequiredRules(true, REQUIRED_MSG)]}
          isEditable={isEditable}
          initialValue={origin}
          maxLength={MAXIMUM_NUMBER_OF_PRODUCT_ORIGIN_TEXT}
        />

        <InputForm
          form={form}
          label="제조사"
          name="manufacturer"
          className={isCompare && compareProductVersion(manufacturer, comparisonData.manufacturer)}
          rules={[formRequiredRules(true, REQUIRED_MSG)]}
          isEditable={isEditable}
          initialValue={manufacturer}
          maxLength={MAXIMUM_NUMBER_OF_PRODUCT_MANUFACTURER_TEXT}
        />
      </div>
    </ProductDetailPanel>
  );
};

export default ProductAfterService;
